export let Constants = {
  // todo luci
  SERVER_ENDPOINT:
    !process.env.NODE_ENV || process.env.NODE_ENV === "development"
      ? process.env.REACT_APP_API_ENDPOINT || "http://localhost:8080"
      : "https://api.clpstudio.ro",
  STORAGE_JWT_TOKEN_KEY: "STORAGE_JWT_TOKEN_KEY",
  STORAGE_EMAIL_KEY: "STORAGE_EMAIL_KEY",
  STORAGE_FIRST_NAME_KEY: "STORAGE_FIRST_NAME_KEY",
  STORAGE_LAST_NAME_KEY: "STORAGE_LAST_NAME_KEY",
  STORAGE_USER_ID_KEY: "STORAGE_USER_ID_KEY",
  STORAGE_CAN_ADD_PAPER: "STORAGE_CAN_ADD_PAPER",
  STORAGE_AUTH_ROLE: "STORAGE_AUTH_ROLE",

  LIST_TYPE_DEPARTMENT: "DEPARTMENT",
  LIST_TYPE_USER_ROLE: "USER_ROLE",
  LIST_TYPE_USER_POSITION: "USER_POSITION",
  LIST_TYPE_ACQUISITION_CATEGORY: "ACQUISITION_CATEGORY",
  LIST_TYPE_FINANCE_SOURCE: "FINANCE_SOURCE",

  MIN_PASSWORD_LENGTH: 6,

  DEFAULT_VAT: 21,
};
